const getId = () => Math.random().toString(16).slice(2);

const recommends = [
  {
    title: 'Eternos',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/32B4BD1D25CFC1509FD336C666ED7FCD684B9E6BCDF397E3996FD86720DA624D/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Cavaleiro da Lua',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/7281674587A05541775E4A5E08BDBFB33CC9EDED35A938EB9049BC6EDB4E2A09/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'A Era do Gelo: Histórias do Scrat',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/A799B436660FB96CB16C6B78BCF5A279D44383050A51ECD7BC26663FE4130E34/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Viúva Negra',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/D90790AA936253564925BE09CD4D0D110F01637CAA3557A656D2DE59F605458B/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Loki',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/E6576E148DE300802FB10457B0FC898A1718F4B759054329B54D919CF6872C3A/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Jungle Cruise',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/C99843353495FE471FE0A7AD912DB4535FE27274BC34B52DD1B1943BF6204EA0/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Red - Crescer é uma Fera',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/524B37D8DA07F84EA2F864B880AEADBC8AA26B034BACFDDB11D91E7F58083A0E/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Encanto',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/BA4233111A988120193BEB3DC1231E6AE233CB0432BDE42DD5E316027F30D912/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Cruella',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/306BD77719A275BA551B9F9883EA1080F3A758A4D78EBE129F05592913DCB25E/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'What If...?',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/72413ED0B1C82EF42C205C73BDF419C3E36FB42BA27394D991633614F63B90A1/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Luca',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/AD254DF69DADAC2F183D8289DCD56AE705304234938DC633291D11B4E1341A5E/badging?width=400&aspectRatio=1.78&format=jpeg&label=disneyplusoriginal',
    _id: getId(),
  },
  {
    title: 'Capitão América: O Primeiro Vingador da Marvel Studios',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/B19319EAD5D4AC6BABC3D945D65C2BEE0211FEA5C6CCAFD529AC9CEE2630AD87/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
  {
    title: 'Os Simpsons',
    image:
      'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/15E3C2D078646B078A78A85D985C421A8357FB98D98E99180733EB68855AFA7F/scale?width=400&aspectRatio=1.78&format=jpeg',
    _id: getId(),
  },
];

export default recommends;
